import React from "react";
import ContactList from "../../../_components/Contacts/ContactList";
import {
    getCustomers, getCustomerKpis, deleteCustomer,
    AREAS, STATUSES, SEARCH_TYPES,
} from "../../../_services/contact.service";
import { isBusinessUnitUser, isSuperAdmin, canAccessAccounting } from '../../../utils/roleConstants';

export default function Customers() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // Shipping User and BUM can only view — hide create button
    const viewOnly = !(isSuperAdmin(user) || isBusinessUnitUser(user) || canAccessAccounting(user));
    return (
        <ContactList
            title="Customer List"
            type="Customer"
            fetchList={getCustomers}
            fetchKpis={getCustomerKpis}
            deleteItem={deleteCustomer}
            hideCreate={viewOnly}
            viewOnly={viewOnly}
            AREAS={AREAS}
            STATUSES={STATUSES}
            SEARCH_TYPES={SEARCH_TYPES}
        />
    );
}
